import React from "react";
import "../../styles/StaticPages.css";

const PrivacyNotice: React.FC = () => {
  return (
    <>
      <div className="static-hero">
        <div className="static-hero-inner">
          <h1>Privacy Information Notice</h1>
        </div>
      </div>
      <div className="static-page-container">
        <div className="static-content">
          <section className="privacy-section">
            <h2>Data Protection & Compliance</h2>
            <p>
              <strong>
                Before sending internal links to company documents, make sure
                that the recipient has the necessary access rights.
              </strong>{" "}
              Sending such links to external or unauthorized recipients may lead
              to data protection or compliance violations.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Internal Links & Access Rights</h2>
            <p>
              When sharing links generated through Shortfy, please ensure that:
            </p>
            <ul className="privacy-list">
              <li>The recipient has the appropriate access permissions</li>
              <li>The content is suitable for the intended audience</li>
              <li>
                No confidential information is shared with unauthorized parties
              </li>
              <li>All company policies regarding data sharing are followed</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Your Responsibilities</h2>
            <p>
              As a user of Shortfy, you are responsible for ensuring that all
              links you create and share comply with CGI's policies and values.
              Please exercise caution and good judgment when sharing company
              resources.
            </p>
          </section>

          <section className="privacy-section">
            <h2>CGI Members Privacy Information Notice</h2>
            <p>
              Please download the{" "}
              <a
                href="https://intranet.ent.cgi.com/browse/priv/global/Documents/Privacy_Intranet_Library_EN/Privacy_Notice/CGI_GP_CGI_Partner_Privacy_Information_Notice.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                CGI Members Privacy Information Notice
              </a>{" "}
              from the CGI Intranet to access this information.
            </p>
            <p>
              If you have difficulty opening the link, visit the{" "}
              <a
                href="https://intranet.ent.cgi.com/Pages/default.aspx"
                target="_blank"
                rel="noopener noreferrer"
              >
                CGI Intranet
              </a>{" "}
              and go to{" "}
              <strong>Browse CGI &gt; Legal &gt; Global Data Privacy</strong>{" "}
              and click on the link for the PIN PDF.
            </p>
          </section>
          <section className="privacy-section">
            <h2>Questions?</h2>
            <p>
              If you have any questions about data protection or compliance,
              please contact your local IT security team or compliance officer.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default PrivacyNotice;
